module.exports = __webpack_public_path__ + "files/a490e3be8ae63d75d68801bfd78e7999.png";